import {ComponentProps, useEffect, useState} from "react";
import {RouteComponentProps, useParams} from "react-router";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {Card, Form, InputNumber, message, Modal, Radio, Switch, Tabs, TabsProps} from "antd";
import DetailTab from "./components/DetailTab";
import ExpressTab from "./components/ExpressTab";
import PaymentTab from "./components/PaymentTab";
import ReportsTab from "./components/ReportsTab";
import {useForm} from "antd/lib/form/Form";
import dayjs from "dayjs";
import * as api from "../../apis/salesOrder";
import * as sampleCalcProportionApi from "../../apis/sampleCalcProportion";
import * as contractApi from "../../apis/platforms/admin/contract";
import * as rebateApi from "../../apis/rebate";
import * as sampleApi from "../../apis/sample";
import {useRequest} from "ahooks";
import ModifyGiveawayModal from "./components/ModifyGiveawayModal";
import ModifyShippingCostModal from "./components/ModifyShippingCostModal";
import BusinessConfirmModal from "./components/BusinessConfirmModal";
import ProductSelectModal from "../../components/ProductSelectModal";
import {StandardColumnsType} from "../../components/StandardTable";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import {RootState} from "../../models";
import {PlatformType} from "../../utils/constants";
import SampleSelectModal from "../../components/SampleSelectModal";
import WarehouseVoucherTab from "./components/WarehouseVoucherTab";


type SalesOrderDetailRouteParam = {
    id: string
}

function SalesOrderDetail(props: RouteComponentProps<SalesOrderDetailRouteParam>) {
    const id = useParams<SalesOrderDetailRouteParam>().id;
    const [form] = useForm();
    const [record, setRecord] = useState<any>({});
    const [enableEdit, setEnableEdit] = useState(false);
    const [giveaways, setGiveaways] = useState<Array<any>>([]);
    const [shippingModifyParams, setShippingModifyParams] = useState<any>({});
    const [businessConfirmOrderType, setBusinessConfirmOrderType] = useState<string>();
    const platform = useSelector<RootState, RootState['auth']>(state => state.auth)?.user?.platform ?? PlatformType.Dealer;
    const [businessConfirmModalVisible, setBusinessConfirmModalVisible] = useState(false);
    const [modifyShippingCostModalVisible, setModifyShippingCostModalVisible] = useState(false);
    const [modifyGiveawayModalVisible, setModifyGiveawayModalVisible] = useState(false);
    const [contract, setContract] = useState<any>({});
    const [sampleSelectModalVisible, setSampleSelectModalVisible] = useState(false);
    const [enableRebate, setEnableRebate] = useState(false);
    const [useRebate, setUseRebate] = useState(false);
    const [rebateConfirmVisible, setRebateConfirmVisible] = useState(false);

    /**
     * Force Submit,
     * force: Sample,
     * restrictForce: Restrict,
     */
    const [forceSubmitOption, setForceSubmitOption] = useState<any>({force: false, restrictForce: false});


    const {loading: loadingData, run: getData} = useRequest(api.getSalesOrderDetail, {
        manual: false,
        defaultParams: [parseInt(id)],
        onSuccess(res) {
            setRecord(res?.data.data || {});
            form.setFieldsValue(res?.data?.data || {});
            setEnableEdit(false);
        }
    });

    const {loading: loadingGetContract, run: runGetContract} = useRequest(contractApi.getContractById, {
        manual: true,
        onSuccess(res) {
            setContract(res.data.data);
        }
    });

    const {loading: loadingGetRebatesRemain, runAsync: runGetRebatesRemain} = useRequest(rebateApi.hasRemain, {
        manual: true,
        defaultParams: [parseInt(id)],
        onSuccess(res) {
            if (res.data.data) {
                setRebateConfirmVisible(true);
            } else {
                doSubmit(parseInt(id))
            }
        }
    });

    const {loading: loadingSave, run: runSave} = useRequest(api.saveSalesOrder, {
        manual: true,
        onSuccess(res) {
            message.success('保存成功');
            getData(parseInt(id));
        }
    })

    const {loading: loadingSubmit, runAsync: doSubmit} = useRequest(api.submitSalesOrder, {
        manual: true,
        onSuccess(res) {
            if (res.data.code == 0) {
                message.success('提交成功');
                setForceSubmitOption({force: false, restrictForce: false});
                if (Array.isArray(res.data.data)) {
                    const orderCodes = res.data.data.filter((o: any) => o.id !== parseInt(id)).map((o: any) => o.code);
                    if (orderCodes.length > 0) {
                        Modal.warning({
                            title: '提示',
                            // content: `因商品限购数量限制，已自动拆分成多笔订单，新的订单号：${orderCodes}。`
                            content: `因商品限购数量限制，已自动拆单，新增订单号：${orderCodes.join('， ')}。`
                        });
                    }

                }
                getData(parseInt(id));

            } else {
                const modal = Modal.confirm({
                    title: '提示',
                    content: (<div style={{whiteSpace: 'pre-line'}}>{res.data.message}</div>),
                    okText: '继续下单',
                    cancelText: '取消',
                    onCancel: () => modal.destroy(),
                    onOk: () => {
                        let forceKey;
                        if (res.data.code == 1) {
                            // need force to submit sample
                            forceKey = 'force';
                        } else if (res.data.code == 2) {
                            //     need force to submit restrict
                            forceKey = 'restrictForce';
                        } else {
                            message.error("网络错误。");
                            return;
                        }
                        const tmpForceOption = {...forceSubmitOption, [forceKey]: true};
                        doSubmit(parseInt(id), useRebate, tmpForceOption);
                        setForceSubmitOption({...tmpForceOption});
                        modal.destroy();
                    },
                });
            }
        }
    });

    const {loading: loadingModifyGiveaway, run: runModifyGiveaway} = useRequest(api.modifyGiveaway, {
        manual: true,
        onSuccess(res) {
            message.success('修改赠品成功');
            getData(parseInt(id));
        }
    });

    const {loading: loadingModifyShippingCost, run: runModifyShippingCost} = useRequest(api.modifyShippingCost, {
        manual: true,
        onSuccess(res) {
            message.success('修改运费成功');
            getData(parseInt(id));
        }
    });

    const {loading: loadingModifyOrderType, run: runModifyOrderType} = useRequest(api.modifyOrderType, {
        manual: true,
        onSuccess(res) {
            message.success('商务确认成功');
            setBusinessConfirmModalVisible(false);
            getData(parseInt(id));
        }
    });

    const {loading: loadingSampleAdd, run: runAddSample} = useRequest(api.addSamples, {
        manual: true,
        onSuccess(res) {
            message.success('样品添加成功');
            getData(parseInt(id));
            setSampleSelectModalVisible(false);
        }
    })

    useEffect(() => {
        if (record.contractId) {
            runGetContract(record.contractId);
        }
    }, [record.contractId]);
    // useEffect(()=>{
    //     if(parseInt(id) &&platform==PlatformType.Dealer){
    //         runGetRebatesRemain(parseInt(id));
    //     }
    // },[id])


    const handleSampleAdd = () => {
        setSampleSelectModalVisible(true);
    }

    const handleBusinessConfirm = () => {
        setBusinessConfirmOrderType(form.getFieldValue('orderType'));
        setBusinessConfirmModalVisible(true);
    }

    const handleModifyShippingCost = () => {
        const params: any = {};
        params.orderId = parseInt(id);
        params.expressId = form.getFieldValue('expressId');
        params.expectShippingCost = form.getFieldValue('expectShippingCost');
        setShippingModifyParams(params);
        setModifyShippingCostModalVisible(true);
    }

    const handleModifyGiveaway = () => {
        const products: Array<any> = form.getFieldValue('item') || [];
        setGiveaways(products.filter(p => !!p.enableGiveaway));
        setModifyGiveawayModalVisible(true);
    }

    const finishModifyGiveaway = (values: any) => {
        const params: any = {orderId: parseInt(id), remark: values.remark};
        params.details = [...values.giveaways || []].map(p => ({
            detailId: p.id,
            productId: p.productId,
            qty: p.qty
        })).filter(p => !!p.productId);
        runModifyGiveaway(params)
        setModifyGiveawayModalVisible(false);
    }

    const finishModifyShippingCost = (values: any) => {
        const params: any = {...values};
        params.freight = params.expectShippingCost - params.freight;
        runModifyShippingCost(params);
        setModifyShippingCostModalVisible(false);
    }

    const finishBusinessConfirm = (orderType: string, associateNum?: string) => {
        const params = {orderId: parseInt(id), orderType, associateNum};
        runModifyOrderType(params);
    }

    const finishSampleSelected = (keys?: Array<number>, records?: Array<any>) => {
        const params = (records || []).map(r => ({...r, sampleId: r.id}));
        if ((records || []).some(r => !r.qty)) {
            message.error('请输入数量');
            return;
        }
        runAddSample(id, params);
    }


    const handleSaveOrder = () => {
        form.validateFields().then(((values: any) => {
            runSave(values);
        }))
    }

    const handleSubmit = (id: number) => {
        if (platform === PlatformType.Dealer) {
            runGetRebatesRemain(id);
        }
        // if(enableRebate){
        //     setRebateConfirmVisible(true);
        // }else{
        //     doSubmit(id, false);
        // }
    }

    const items: TabsProps['items'] = [
        {
            key: 'detail',
            label: '订单',
            children: <DetailTab form={form} record={record} key={'detail'} enableEdit={enableEdit}
                                 setEnableEdit={setEnableEdit} doSubmit={handleSubmit}
                                 handleBusinessConfirm={handleBusinessConfirm}
                                 handleModifyShippingCost={handleModifyShippingCost}
                                 handleModifyGiveaway={handleModifyGiveaway}
                                 handleSampleAdd={contract?.sampleRule === 'quota' ? handleSampleAdd : undefined}/>
        },
        {
            key: 'express',
            label: '物流',
            children: <ExpressTab record={record}/>
        },
        {
            key: 'payment',
            label: '付款',
            children: <PaymentTab record={record}/>
        },
        {
            key: 'reports',
            label: '质检报告',
            children: <ReportsTab orderId={record.id}/>
        },
    ];

    if (record.orderSource === '新美年') {
        items.push({
            key: 'warehouseVoucher',
            label: '美年入库凭证',
            children: <WarehouseVoucherTab orderId={record.code}/>
        })
    }

    return <PageHeaderLayout withFooterBar={enableEdit} onOk={handleSaveOrder} onCancel={() => setEnableEdit(false)} btnLoading={loadingSave}>
        <Card>
            <Tabs items={items} destroyInactiveTabPane/>
        </Card>
        <ModifyGiveawayModal giveaways={giveaways} open={modifyGiveawayModalVisible}
                             onCancel={() => setModifyGiveawayModalVisible(false)} onFinish={finishModifyGiveaway}/>
        <ModifyShippingCostModal params={shippingModifyParams} open={modifyShippingCostModalVisible}
                                 onCancel={() => setModifyShippingCostModalVisible(false)}
                                 onFinish={finishModifyShippingCost}/>
        <BusinessConfirmModal orderType={businessConfirmOrderType} open={businessConfirmModalVisible}
                              onCancel={() => {
                                  if (!loadingModifyOrderType) {
                                      setBusinessConfirmModalVisible(false)
                                  }
                              }} onFinish={finishBusinessConfirm}
                              confirmLoading={loadingModifyOrderType}/>
        {sampleSelectModalVisible && <SampleSelectModal key={'sample-selected'}
                                                        multiple
                                                        contractId={record.contractId}
                                                        open={sampleSelectModalVisible}
                                                        onCancel={() => setSampleSelectModalVisible(false)}
                                                        confirmLoading={loadingSampleAdd}
                                                        onComplete={finishSampleSelected}/>}
        <Modal width={400}
               open={rebateConfirmVisible}
               title={'使用返利'}
               onOk={() => {
                   doSubmit(parseInt(id), useRebate);
                   setRebateConfirmVisible(false);
               }} confirmLoading={loadingSubmit}
               onCancel={() => setRebateConfirmVisible(false)}>
            是否使用返利？&nbsp;&nbsp;
            <Switch checkedChildren={'是'} unCheckedChildren={'否'} onChange={(checked) => setUseRebate(checked)}/>
            <br/>
            <a onClick={() => window.open('/rebate/rebate')}>查看返利单信息</a>
        </Modal>
    </PageHeaderLayout>
}

export default SalesOrderDetail;
